export default {
  data() {
    return {
      formUser: {
        basic: {}, // basic database info
        char: {}, // characteristcis of user
        pref: {}, // prefernces
        rev: {}, // doc. revisions (current)
        stats: {} // stats local plus remote stats will be generated
      },
      formUserSelect: {
        app: "", // app name
        api: "", // app id
        cauth: null, // compant authroty
        caccess: "", // access limited defined by company
        ctag: "", // company tag
        cid: "", // compant id
        cname: "", // company legal name
        cshort: "", // short name
        cdid: "", // company id
        cidg: "",
        fauth: null, // authroty level for facility
        faccess: "", // access limt defined by
        fname: "", // facility name
        ftag: "", // facility tag
        fid: "", // facility id
        fdid: "", // facility id
        fidg: "",
        fshort: "" // facility short name
      }, // critical for selections
      formUserPref: {
        page: {
          fav: "", // favourite page
          home: "", // prefereed home page when browing app
          signin: "", // prefered page at login
          signout: "" // prefered page at sign out
        },
        search: {
          user: "company", // who can search you
          data: "", // restrtcions
          limit: "1000",
          result: "100",
          privacy: "Role", // what is displayed when others search you
          display: "50"
        },
        settings: {
          theme: "Business",
          mode: "Light",
          date: "DD/MM/YYYY", // date format
          autologoff: "Off", // auto log off
          ln: "English" // language
        },
        view: {
          snackbar: true, // display snackbars
          barstatus: true, // display of status bat
          barbottom: true, // display snackbars
          barnavigation: true // display snackbars
        }
      }
    };
  }
};
